// extracted by mini-css-extract-plugin
export var container = "_sw-0";
export var inputWidth = "_sw-1";